import { render, staticRenderFns } from "./BsiAddress.vue?vue&type=template&id=c8a8ce9c&scoped=true&"
import script from "./BsiAddress.vue?vue&type=script&lang=js&"
export * from "./BsiAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a8ce9c",
  null
  
)

export default component.exports